<template>
	<div class="vacationDaysWrapper">
		<template v-if="Number(line.type_id) === 0">
			<div class="countDays">
				<span class="subTitle">Total days: </span>
				<b>{{ getDatesCount() }}</b>
			</div>

			<ul class="dateList">
				<li
						v-for="(date, index) in getFormattedDates()"
						:key="`${date.month}-${date.day}-${index}`"
				>
					<span class="m">{{ date.month }}</span>.<span class="d">{{ date.day }}</span>
				</li>
			</ul>
		</template>

		<div
				v-else-if="Number(line.type_id) === 1"
				class="compensation"
		>
			Compensation
		</div>
	</div>
</template>

<script>
export default {
	name: "SplitContent",
	props: {
		item: Object,
		line: Object
	},
	methods: {
		getFormattedDates() {
			if (!this.line.dates) return [];

			// Форматуємо дати у вигляді об'єктів
			const formattedDates = this.line.dates.split(',').map(date => this.formatDate(date));

			// Сортуємо дати за місяцем і днем
			formattedDates.sort((a, b) => {
				if (a.month !== b.month) {
					return a.month.localeCompare(b.month); // Порівнюємо місяці
				}
				return a.day.localeCompare(b.day); // Якщо місяці однакові, порівнюємо дні
			});

			return formattedDates;
		},
		getDatesCount() {
			return this.line.dates ? this.line.dates.split(',').length : 0;
		},
		formatDate(date) {
			const parts = date.split('-'); // ["2025", "02", "17"]
			if (parts.length === 3) {
				return { month: parts[1], day: parts[2] }; // { month: "02", day: "17" }
			}
			return { month: "--", day: "--" }; // Фоллбэк
		}
	}
};
</script>

<style scoped lang="scss">
.vacationDaysWrapper {
	.countDays {
		width: 100%;
		margin-bottom: 3px;
		b {
			color: #00e32d;
		}
	}
	.dateList {
		//background: #383844;
		margin: 0;
		padding: 3px 5px;
		list-style: none;
		font-size: 12px;
		color: #1dab39;
		display: flex;
		flex-wrap: wrap;
		gap: 4px;
		.m { color: #717171; }
		.d { color: #8d8d8d; font-weight: bold }
	}
	.compensation {
		color: var(--base-orange);
	}
}
</style>
